import { v4 } from 'uuid'

const getBrowserCrypto = () => (typeof window === 'undefined' ? undefined : window.crypto)

export const createUuid = () => {
  const browserCrypto = getBrowserCrypto()

  if (browserCrypto?.randomUUID) {
    return browserCrypto.randomUUID()
  }

  return v4()
}
